import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const createSession = async (title) => {
  const { data } = await api.post(`/sessions`, { title });
  return data;
};

export const fetchSession = async (id) => {
  const { data } = await api.get(`/sessions/${id}`);
  return data;
};

export const listSessions = async () => {
  const { data } = await api.get(`/sessions`);
  return data;
};

export const uploadAudioChunk = async (id, blob, speaker, ts) => {
  const form = new FormData();
  const ext = blob.type.includes("webm") ? "webm" : blob.type.includes("mp4") ? "mp4" : "webm";
  form.append("file", blob, `chunk.${ext}`);
  form.append("speaker", speaker);
  form.append("ts", String(ts));
  const { data } = await api.post(`/sessions/${id}/audio`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data;
};

export const markMoment = async (id, ts, windowSec = 15) => {
  const { data } = await api.post(`/sessions/${id}/mark-moment`, { ts, window_sec: windowSec });
  return data;
};

export const endSession = async (id) => {
  const { data } = await api.post(`/sessions/${id}/end`);
  return data;
};
